import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FAQSection from '@/components/feature/FAQSection';
import HeroSection from './components/HeroSection';
import TrustBadges from './components/TrustBadges';
import ServicesPreview from './components/ServicesPreview';
import AboutSnippet from './components/AboutSnippet';
import BrandsSection from './components/BrandsSection';
import WhyUsSection from './components/WhyUsSection';
import TestimonialsSection from './components/TestimonialsSection';
import ProjectsShowcase from './components/ProjectsShowcase';
import CTASection from './components/CTASection';
import { useCMS } from '@/hooks/useCMS';

const FAQ_DEFAULT = {
  label: 'ხშირად დასმული კითხვები',
  title: 'გაქვთ კითხვები?',
  subtitle: 'ქვემოთ მოცემულია ჩვენი კლიენტების ყველაზე ხშირი კითხვები. სხვა კითხვის შემთხვევაში, გთხოვთ დაგვიკავშირდეთ.',
  items: [
    { question: 'რა სახის სამშენებლო მასალებს ამარაგებს Phoenix?', answer: 'Phoenix ამარაგებს პრემიუმ სამშენებლო მასალების ფართო სპექტრს, მათ შორის: Laminam-ის ულტრა-თხელ კერამიკულ ფილებს, Antolini-ს ბუნებრივ ქვის ზედაპირებს, Ardex-ის მაღალი ეფექტურობის სამშენებლო ქიმიას, Tecnopol-ის ჰიდროიზოლაციის სისტემებს, Dicson-ის გარე ტექსტილს და Fodbo-ს იატაკის გადაწყვეტილებებს. ყველა პროდუქტი მოდის მწარმოებლის სრული გარანტიით.' },
    { question: 'შეუძლია Phoenix-ს ინტერიერის დიზაინის კონსულტაციის გაწევა?', answer: 'დიახ! ჩვენი გამოცდილი ინტერიერის დიზაინერების გუნდი გთავაზობთ სრულ კონსულტაციას — კონცეფციის შემუშავებიდან მასალების საბოლოო შერჩევამდე.' },
    { question: 'ახორციელებს თუ არა Phoenix მასალების მონტაჟს?', answer: 'დიახ, ვთავაზობთ პროფესიულ მონტაჟის სერვისს ჩვენი სერტიფიცირებული სპეციალისტების გუნდის მეშვეობით.' },
    { question: 'სად მდებარეობს Phoenix-ის შოურუმი?', answer: 'ჩვენი მთავარი შოურუმი მდებარეობს თბილისში, გელოვანის ქ. N13-ზე. ვმუშაობთ ორშაბათიდან შაბათამდე, 9:30-დან 19:30-მდე.' },
    { question: 'რამდენ ხანს სჭირდება მასალების მიწოდება?', answer: 'საწყობში არსებული მასალები, როგორც წესი, მიეწოდება 1-3 სამუშაო დღეში. სპეციალური შეკვეთებისთვის ვადა შეიძლება განსხვავდებოდეს.' },
    { question: 'შეუძლია Phoenix-ს კომერციული პროექტების მომსახურება?', answer: 'აბსოლუტურად! ჩვენ ვემსახურებით როგორც საცხოვრებელ, ასევე კომერციულ და სამრეწველო პროექტებს. ჩვენი 5,000-ზე მეტი დასრულებული პროექტი მოიცავს სასტუმროებს, ოფისებს, სავაჭრო ცენტრებს, რესტორნებს და მსხვილ საბინაო კომპლექსებს.' },
  ],
};

export default function Home() {
  const faqCms = useCMS('faq_home', FAQ_DEFAULT);
  const faqs = (faqCms.items ?? FAQ_DEFAULT.items).map((item: { question: string; answer: string }) => ({
    question: item.question,
    answer: item.answer,
  }));

  return (
    <div className="font-sans bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <TrustBadges />
        <ServicesPreview />
        <AboutSnippet />
        <BrandsSection />
        <WhyUsSection />
        <TestimonialsSection />
        <ProjectsShowcase />
        <FAQSection
          faqs={faqs}
          label={faqCms.label ?? FAQ_DEFAULT.label}
          title={faqCms.title ?? FAQ_DEFAULT.title}
          subtitle={faqCms.subtitle ?? FAQ_DEFAULT.subtitle}
        />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
